
<template>
<div>
    <div id="map" class="min-h-70"></div>
</div>
</template>

<script >
    export default {
        props : ['zoneliste','nameproject','token','isetudeacc'],     
        data:function(){
            return{
                questionRate:0,
                statusFilterListeners: [],
            };
        },
        beforeDestroy: function(){
            this.statusFilterListeners.forEach(({ element, listener }) => {
                element.removeEventListener('change', listener);
            });
        },
        mounted: function(){
            const redirectToSiteEdition = (nameproject, id) => {
                return () => {
                    window.location.href = '/'+nameproject +'/editSite/'+id+"/" + window.default_locale;
                }
            };

            const token = this.token;
            const GoogleMap = require("@googlemaps/js-api-loader");

            const loader = new GoogleMap.Loader({
                apiKey: token,
                version: "weekly",
                libraries:["geometry","marker"]
            });

            loader.load().then(() => {
                // Initiate map
                let map;
                const isEtudeAcc = this.isetudeacc === true || this.isetudeacc === 1 || this.isetudeacc === '1';
                const mapTypeOptions = {
                    mapTypeControl: isEtudeAcc,
                    mapTypeControlOptions: isEtudeAcc ? {
                        style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
                        mapTypeIds: [
                            google.maps.MapTypeId.ROADMAP,
                            google.maps.MapTypeId.SATELLITE,
                            google.maps.MapTypeId.TERRAIN,
                        ],
                    } : undefined,
                };
                if(this.zoneliste.length == 0){
                    map = new google.maps.Map(document.getElementById("map"), {
                        zoom: 1,
                        mapTypeId: google.maps.MapTypeId.SATELLITE,
                        ...mapTypeOptions,
                        center: {lat: 1, lng: 1},
                        tilt: 0,
                        rotateControl: false,
                        mapId: "90f87356969d889c", // Map ID is required for advanced markers.
                    });
                } else {
                    var data=[]
                    this.zoneliste.forEach(element => {
                        data.push(turf.point([element.longitude,element.latitude]));
                    });
                    var center = turf.centerOfMass(turf.featureCollection(data));
                    var distance = -1;
                    this.zoneliste.forEach(element => {
                        var temp = turf.distance(center,turf.point([element.longitude,element.latitude]));
                        if(temp>distance){
                            distance=temp*3;
                        }
                    });
                    var div = document.getElementById('map');
                    var rapport = distance*1000/div.clientWidth;
                    var zoomRapport = 0;
                    if(rapport<0.019){
                        zoomRapport=22;
                    }else if(rapport <0.037){
                        zoomRapport=21;
                    }else if(rapport <0.075){
                        zoomRapport=20;
                    }else if(rapport <0.149){
                        zoomRapport=19;
                    }else if(rapport <0.299){
                        zoomRapport=18;
                    }else if(rapport <0.597){
                        zoomRapport=17;
                    }else if(rapport <1.194){
                        zoomRapport=16;
                    }else if(rapport <2.389){
                        zoomRapport=15;
                    }else if(rapport <4.777){
                        zoomRapport=14;
                    }else if(rapport <9.555){
                        zoomRapport=13;
                    }else if(rapport <19.102){
                        zoomRapport=12;
                    }else if(rapport <38.218){
                        zoomRapport=11;
                    }else if(rapport <76.437){
                        zoomRapport=10;
                    }else if(rapport <152.874){
                        zoomRapport=9;
                    }else if(rapport <305.748){
                        zoomRapport=8;
                    }else if(rapport <611.496){
                        zoomRapport=7;
                    }else if(rapport <1222.992){
                        zoomRapport=6;
                    }else if(rapport <2445.984){
                        zoomRapport=5;
                    }else if(rapport <4891.968){
                        zoomRapport=4;
                    }else if(rapport <9783.936){
                        zoomRapport=3;
                    }else if(rapport <19567.871){
                        zoomRapport=2;
                    }else{
                        zoomRapport=1;
                    }

                    map = new google.maps.Map(document.querySelector("#map"), {
                        zoom: zoomRapport - 1,
                        mapTypeId: google.maps.MapTypeId.SATELLITE,
                        tilt: 0,
                        ...mapTypeOptions,
                        center: { lng: center.geometry.coordinates[0], lat: center.geometry.coordinates[1]},
                        rotateControl: false,
                        mapId: "90f87356969d889c", // Map ID is required for advanced markers.
                    });
                    var HTMLMarker = require("./maps/HTMLMarker.js");
                    const accMarkersByStatus = { a: [], b: [], c: [], d: [] };

                    const registerAccMarker = (status, marker) => {
                        if (accMarkersByStatus[status]) {
                            accMarkersByStatus[status].push(marker);
                        }
                    };

                    // Helper: create the popup content and marker for a single element (keeps original behavior)
                    const createMarkerFor = (element) => {
                        if(isEtudeAcc) {
                            var poppupContent = document.createElement("div");
                            poppupContent.className = "containeur-fluid d-print-flex flex-column justify-content-around align-content-center";

                            var text = document.createElement("div");
                            text.className = "text-center";

                            text.textContent = element.name + " - " + element.consommationAnnuelle + " MWh/an";
                            poppupContent.appendChild(text);

                            var button = document.createElement('button');
                            button.className ="buttonOriginal";
                            button.addEventListener('click', redirectToSiteEdition(nameproject, element.id));

                            button.setAttribute('id',element.id);
                            
                            var glyph =document.createElement('span')
                            glyph.className="glyphicon glyphicon-search"                            
                            button.appendChild(glyph);
                            poppupContent.appendChild(button);

                            var markerImg = document.createElement('img');
                            markerImg.src = '/image/maps/etudeAcc/'+element.statut+'.png';
                            
                            const advMarker = new google.maps.marker.AdvancedMarkerElement({
                                map,
                                position: { lat: element.latitude, lng: element.longitude},
                                content: markerImg
                            });

                            const infowindow = new google.maps.InfoWindow({ content: poppupContent });
                            advMarker.addListener("click", () => infowindow.open({ anchor: advMarker, map, shouldFocus: false }));
                            registerAccMarker(element.statut, advMarker);

                            return;
                        }

                        if(element.action>0){
                            var poppupContent = document.createElement("div");
                            poppupContent.className = "containeur-fluid d-print-flex flex-column justify-content-around align-content-center";
                            var text = document.createElement("div");
                            text.className = "text-center";
                            text.textContent = element.name;
                            poppupContent.appendChild(text);
                            var text2 = document.createElement("div");
                            text2.className = "text-center";
                            text2.textContent = "Il y a " + element.action + " action(s) à réaliser";
                            poppupContent.appendChild(text2);
                            var button = document.createElement('button');
                            button.className ="buttonOriginal";
                            button.setAttribute('id',element.id);

                            var glyph =document.createElement('span')
                            glyph.className="glyphicon glyphicon-search"
                            button.appendChild(glyph);
                            poppupContent.appendChild(button);
                            button.addEventListener('click', redirectToSiteEdition(nameproject, element.id));
                            
                            var marker = new HTMLMarker.default(element.latitude, element.longitude, element.name.substr(element.name.indexOf(" ")+1), element.name);
                            marker.setMap(map);

                            const infowindow = new google.maps.InfoWindow({ content: poppupContent });
                            marker.addListener("click", () => infowindow.open({ anchor: marker, map, shouldFocus: false }));
                            return;
                        }

                        if(element.building.length == 0){
                            var poppupContent = document.createElement("div");
                            poppupContent.className = "containeur-fluid d-print-flex flex-column justify-content-around align-content-center";

                            var text = document.createElement("div");
                            text.className = "text-center";

                            text.textContent = element.name;
                            poppupContent.appendChild(text);
                            
                            var text2 = document.createElement("div");
                            text2.className = "text-center";
                            text2.textContent = "Il n'y a pas de zone référencée";
                            poppupContent.appendChild(text2);

                            var button = document.createElement('button');
                            button.className ="buttonOriginal";
                            button.setAttribute('id',element.id);
                            var glyph =document.createElement('span')
                            glyph.className="glyphicon glyphicon-search"
                            button.appendChild(glyph);
                            poppupContent.appendChild(button);
                            button.addEventListener('click', redirectToSiteEdition(nameproject, element.id));

                            var marker = new HTMLMarker.default(element.latitude, element.longitude, element.name.substr(element.name.indexOf(" ")+1), element.name);
                            marker.setMap(map);

                            const infowindow = new google.maps.InfoWindow({ content: poppupContent });
                            marker.addListener("click", () => infowindow.open({ anchor: marker, map, shouldFocus: false }));
                            return;
                        }

                        // default case
                        var poppupContent = document.createElement("div");
                        poppupContent.className = "containeur-fluid d-print-flex flex-column justify-content-around align-content-center";
                        var text = document.createElement("div");
                        text.className = "text-center";
                        text.textContent = element.name;
                        poppupContent.appendChild(text);
                        var button = document.createElement('button');
                        button.className ="buttonOriginal";
                        button.addEventListener('click', redirectToSiteEdition(nameproject, element.id));
                        button.setAttribute('id',element.id);
                        var glyph =document.createElement('span')
                        glyph.className="glyphicon glyphicon-search"
                        button.appendChild(glyph);
                        poppupContent.appendChild(button);

                        var markerImg = document.createElement('img');
                        markerImg.src = '/image/maps/'+element.statut+'.png';
                        const advMarker2 = new google.maps.marker.AdvancedMarkerElement({ map, position: { lat: element.latitude, lng: element.longitude}, content: markerImg });
                        const infowindow = new google.maps.InfoWindow({ content: poppupContent });
                        advMarker2.addListener("click", () => infowindow.open({ anchor: advMarker2, map, shouldFocus: false }));
                    };

                    // Helper: create a clustered marker for multiple elements at identical coordinates
                    const createClusterMarker = (group) => {
                        const first = group[0];
                        var poppupContent = document.createElement("div");
                        poppupContent.className = "containeur-fluid d-print-flex flex-column justify-content-around align-content-center";

                        var title = document.createElement("div");
                        title.className = "text-center font-weight-bold";
                        title.textContent = group.length + " sites";
                        poppupContent.appendChild(title);

                        var list = document.createElement("div");
                        list.className = "d-flex flex-column";
                        group.forEach(el => {
                            var line = document.createElement("div");
                            line.className = "d-flex justify-content-between align-items-center my-1";
                            var name = document.createElement("div");
                            name.textContent = el.name;
                            var btn = document.createElement("button");
                            btn.className = "buttonOriginal btn-sm";
                            btn.textContent = "Voir";
                            btn.addEventListener('click', redirectToSiteEdition(nameproject, el.id));
                            line.appendChild(name);
                            line.appendChild(btn);
                            list.appendChild(line);
                        });
                        poppupContent.appendChild(list);

                        var clusterDiv = document.createElement("div");
                        clusterDiv.className = "cluster-marker";
                        clusterDiv.style.background = "#ff6b6b";
                        clusterDiv.style.color = "white";
                        clusterDiv.style.borderRadius = "50%";
                        clusterDiv.style.width = "36px";
                        clusterDiv.style.height = "36px";
                        clusterDiv.style.display = "flex";
                        clusterDiv.style.alignItems = "center";
                        clusterDiv.style.justifyContent = "center";
                        clusterDiv.textContent = group.length;

                        const clusterMarker = new google.maps.marker.AdvancedMarkerElement({ map, position: { lat: first.latitude, lng: first.longitude }, content: clusterDiv });
                        const infowindow = new google.maps.InfoWindow({ content: poppupContent });
                        clusterMarker.addListener("click", () => infowindow.open({ anchor: clusterMarker, map, shouldFocus: false }));
                        if (isEtudeAcc) {
                            registerAccMarker(first.statut, clusterMarker);
                        }
                    };

                    // Group by identical coordinates and create markers
                    const groups = {};
                    this.zoneliste.forEach(el => {
                        // En mode ACC, un regroupement ne mélange jamais deux statuts afin
                        // que chaque filtre puisse masquer l'intégralité de sa catégorie.
                        const key = `${el.latitude}_${el.longitude}_${isEtudeAcc ? el.statut : ''}`;
                        if (!groups[key]) groups[key] = [];
                        groups[key].push(el);
                    });
                    Object.values(groups).forEach(group => {
                        if (group.length === 1) createMarkerFor(group[0]);
                        else createClusterMarker(group);
                    });

                    if (isEtudeAcc) {
                        document.querySelectorAll('.js-acc-status-filter').forEach(filter => {
                            const listener = () => {
                                const status = filter.getAttribute('data-status');
                                (accMarkersByStatus[status] || []).forEach(marker => {
                                    marker.map = filter.checked ? map : null;
                                });
                            };

                            filter.addEventListener('change', listener);
                            this.statusFilterListeners.push({ element: filter, listener });
                            listener();
                        });
                    }

                    const { getCadastreLayer, getPLULayer, getOverlayControls, getOverlayLegend } = require("./maps/additional-layers.js");
                    const { EnedisHTLines, EnedisBTLines, EnedisDeliveryPosts/*, RteLines, RtePylones, RtePostes*/ } = require("./maps/opendata-carto-module.js");

                    const overlaysMenu = getOverlayControls({
                        'cadastre': getCadastreLayer(),
                        'urbanism': getPLULayer(map),
                        'ht-lines': new EnedisHTLines(),
                        'bt-lines': new EnedisBTLines(),
                        'posts': new EnedisDeliveryPosts(),
                        //'rte-posts': new RtePostes(),
                        //'rte-lines': new RteLines(),
                        //'rte-pylones': new RtePylones(),
                    }, map);

                    map.controls[google.maps.ControlPosition.TOP_LEFT].push(overlaysMenu);

                    const overlayLegend = getOverlayLegend();
                    map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(overlayLegend);
                }
            });
                var nameproject =this.nameproject;
        },

    }

</script>
